/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2020 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

import { envParam } from './base';

/**
 * Stage environment overrides.
 */
// const API_BASE_URL = 'https://aiadmin-api-pplus.etext-stg.pearsondev.tech/api/v1';

const BASE_URL = 'https://aiadmin-api-pplus.etext-stg.pearsondev.tech';
const PROD_BASE_URL = 'https://aiadmin-api-pplus.etext-prd.pearsonprd.tech';
const BERLIN_STG_URI = 'https://berlin-api-pplus.etext-stg.pearsondev.tech';
const BERLIN_PROD_URI = 'https://berlin-api-pplus.etext-prd.pearsonprd.tech';
const STACKB_PORT = '8443';
const V1_PATH = '/api/v1';
const V2_PATH = '/api/v2.0';
const V3_PATH = '/api/v3.0';

// Set stackB URL based on env query parameter (stg or prod only)
let STACK_B_BASE_URL;
let BERLIN_URI_FOR_STACK;
switch (envParam) {
  case 'prod':
    STACK_B_BASE_URL = PROD_BASE_URL;
    BERLIN_URI_FOR_STACK = BERLIN_PROD_URI;
    break;
  default:
    STACK_B_BASE_URL = BASE_URL;
    BERLIN_URI_FOR_STACK = BERLIN_STG_URI;
}

const stg = {
  ENVIRONMENT: 'stg',
  PARTNER_ENV: 'stg',
  BERLIN_ENV: 'stage',
  DELAYED_GTM: false,
  GTM_CONTAINER_ID: 'GTM-WTX7GQN',
  GTM_AUTH: '2RfxHnUh9vgQxsMrRfX-zQ',
  GTM_PREVIEW: 'env-5',
  INT_AZURE_CLIENT_ID: 'a899bb0f-bfde-4ae6-9939-b3a1ccf74869',
  INT_BASE_URL: `${BASE_URL}${V1_PATH}`,
  AI_ADMIN_API_BASE_URL: `${BASE_URL}${V1_PATH}`,
  AI_ADMIN_API_BASE_URL_V2: `${BASE_URL}${V2_PATH}`,
  AI_ADMIN_API_BASE_URL_V3: `${BASE_URL}${V3_PATH}`,
  AI_ADMIN_API_BASE_URL_STACKB: `${STACK_B_BASE_URL}:${STACKB_PORT}${V1_PATH}`,
  AI_ADMIN_API_BASE_URL_V2_STACKB: `${STACK_B_BASE_URL}:${STACKB_PORT}${V2_PATH}`,
  AI_ADMIN_API_BASE_URL_V3_STACKB: `${STACK_B_BASE_URL}:${STACKB_PORT}${V3_PATH}`,
  BERLIN_API_URI: 'https://berlin-api-pplus.etext-stg.pearsondev.tech',
  BERLIN_API_URI_STACKB: `${BERLIN_URI_FOR_STACK}:${STACKB_PORT}`
};

export default stg;
